module.exports = __webpack_public_path__ + "img/like.fffa6dbe.png";